import React, { useEffect, useState } from 'react'

// react redux
import { connect } from "react-redux";

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// API
import { validateResetPassword } from 'utlis/Apis/Customers_API';

// react toastify
import { toast } from "react-toastify";

// themes
import Theme1 from './Themes/ResetPasswordTheme1/ResetPassword'

function ResetPassword(props) {
    // props
    const {
        globalAppTheme,

        match,

        commonToken,

        setGlobalLoading
    } = props

    // states
    const [isRequestValid, setIsRequestValid] = useState(false)

    const [userIdFromUrl, setUserIdFromUrl] = useState("")
    const [userTokenFromUrl, setUserTokenFromUrl] = useState("")

    // checking if reset password details are valid
    useEffect(() => {
        if (match?.params?.userId && match?.params?.userToken) {

            setUserIdFromUrl(match.params.userId) // setting details
            setUserTokenFromUrl(match.params.userToken)  // setting details

            // global loading
            setGlobalLoading(true)

            const dataToValidate = {
                userId: match.params.userId,
                userToken: match.params.userToken
            }

            // validating user details
            validateResetPassword(commonToken ?? "", dataToValidate).then(res => {
                // global loading
                setGlobalLoading(false)

                const resData = res.data

                if (resData?.success) {  // if link is valid
                    setIsRequestValid(true)
                }

                if (resData?.error) {  // if link is inValid
                    setIsRequestValid(false)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.info(resData?.message ?? "Unauthorized Access", {
                        autoClose: 2500,
                        onClose: () => { },
                    });
                }
            }).catch(err => {
                console.log("errr ", err);

                // global loading
                setGlobalLoading(false)
            })
        }
    }, [commonToken])

    return (
        <React.Fragment>
            {
                isRequestValid ? (
                    <React.Fragment>
                        {
                            globalAppTheme === 'theme1' ? (
                                <Theme1
                                    userIdFromUrl={userIdFromUrl}
                                    userTokenFromUrl={userTokenFromUrl}
                                />
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
        commonToken: state.auth.commonToken,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(ResetPassword);